import {
  all,
  call,
  select,
  put,
  takeLatest,
  takeEvery,
  fork
} from "redux-saga/effects"
import { WINDOW } from "constants/environment"
import queryString from "query-string"
import { fetchMyMazdaComponents } from "apis/mymazda"
import { Body } from "containers"
import { scrollToOffset } from "utils"
import {
  actionTypes,
  selectors,
  actionCreators
} from "./mymazda"

import {
  selectors as environmentSelectors,
  actionTypes as environmentActionTypes
} from "./environment"

const {
  MYMAZDA_FETCH_START,
  MYMAZDA_FETCH_SUCCESS,
  MYMAZDA_FETCH_ERROR,
  MYMAZDA_UPDATE_ROUTE_COMPONENTS,
  MYMAZDA_FLASH_ADD_MESSAGE,
  MYMAZDA_REFRESH_CURRENT_ROUTE,
  MYMAZDA_TOGGLE_NAV,
  MYMAZDA_CLOSE_ALL,
  MYMAZDA_TOGGLE_USER,
  MYMAZDA_TOGGLE_NOTIFICATIONS
} = actionTypes

function* fetchPageComponents({
  payload
}) {
  const route = yield select(selectors.getRoute(payload.route))
  if (typeof route === "undefined" || !route.fetchUrl) {
    yield put({
      type: MYMAZDA_FETCH_ERROR,
      payload: {
        route: payload.route,
        error: "Route not found"
      }
    })
    return
  }

  try {
    yield put({
      type: MYMAZDA_FETCH_START,
      payload: {
        route: payload.route
      }
    })

    const [pathname = "", search = ""] = route.fetchUrl.split("?")

    const combinedSearch = queryString.stringify({
      ...queryString.parse(payload.search),
      ...queryString.parse(search)
    })

    const {
      errorMsg,
      errorCode,
      data
    } = yield call(fetchMyMazdaComponents, `${pathname}${combinedSearch && ("?" + combinedSearch)}`)

    if (WINDOW) {
      window.scrollTo(0, 0)
    }

    if (errorMsg || errorCode || !data || !data.length) {
      yield put({
        type: MYMAZDA_FETCH_ERROR,
        payload: {
          route: payload.route,
          error: errorMsg || "Something went wrong"
        }
      })
      yield put(actionCreators.addFlashMessage(
        "Sorry, there was a problem loading this page. Please try again later.",
        "ERROR"
      ))
      return
    }

    yield put({
      type: MYMAZDA_FETCH_SUCCESS,
      payload: {
        route: payload.route,
        components: data,
        key: payload.key
      }
    })
  } catch (error) {
    console.warn(error)

    yield put({
      type: MYMAZDA_FETCH_ERROR,
      payload: {
        route: payload.route,
        error: error.message
      }
    })

    yield put(actionCreators.addFlashMessage(
      "Sorry, there was a problem loading this page. Please try again later.",
      "ERROR"
    ))
  }
}

function* handleFlashMessage({
  payload
}) {
  if (payload.timeout <= 0) return
  yield new Promise(resolve => setTimeout(resolve, payload.timeout))
  yield put(actionCreators.removeFlashMessage(payload.id))
}

export function* refreshCurrentRoute() {
  if (!WINDOW) return
  const { pathname, search } = window.location
  yield put(actionCreators.updateRouteComponents(pathname, search))
}

const body = Body

function* handleToggleNav() {
  if (!body) return
  const { navigationOpen, userMenuOpen, notificationMenuOpen } = yield select(selectors.getUiState)
  if (
    window.innerWidth < 620 && // never lock body for tablet or desktop
    (navigationOpen || userMenuOpen || notificationMenuOpen)
  ) {
    const globalNavHeight = yield select(environmentSelectors.getGlobalHeaderHeight)
    // scroll down untill nav stick
    if (window.scrollY < globalNavHeight) {
      yield scrollToOffset(globalNavHeight)
    }
    if (body) body.lock()
  } else if (body) body.unlock()
}

export default function* () {
  yield all([
    fork(function* () {
      yield takeLatest(MYMAZDA_REFRESH_CURRENT_ROUTE, refreshCurrentRoute)
    }),
    fork(function* () {
      yield takeLatest(MYMAZDA_UPDATE_ROUTE_COMPONENTS, fetchPageComponents)
    }),
    fork(function* () {
      yield takeEvery(MYMAZDA_FLASH_ADD_MESSAGE, handleFlashMessage)
    }),
    fork(function* () {
      yield takeLatest([
        MYMAZDA_TOGGLE_NAV,
        MYMAZDA_CLOSE_ALL,
        MYMAZDA_TOGGLE_USER,
        MYMAZDA_TOGGLE_NOTIFICATIONS
      ], handleToggleNav)
    })
  ])
}



// WEBPACK FOOTER //
// ./src/store/actions/mymazda-async.js